module.exports = __webpack_public_path__ + "static/la-ventures--chau-nguyen-fa2e458adddf9e010fef797480fc40e2.mp4";